export default __webpack_public_path__ + "static/media/dego-screenshot-06.dc238e8d.png";